import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { IconChevronRight, SkeletonLabel } from '@noths/polaris-client-ribbons-design-system';
import dynamic from 'next/dynamic';

import { DELIVERY_DRAWER_URL_FRAGMENT_ID } from 'src/fragmentIDs';
import { DeliveryBlockContainer } from '../../containers/DeliveryBlockContainer/DeliveryBlockContainer';
import { DeliveryBlockContextID } from '../DeliveryBlock/types';
import * as styles from './DeliverySection.styles';

const DeliveryAndReturnsDrawer = dynamic(() =>
  import(
    /* webpackChunkName: "delivery_returns_drawer" */ '../DeliveryAndReturnsDrawer/DeliveryAndReturnsDrawer'
  ).then((mod) => mod.DeliveryAndReturnsDrawer),
);

export interface DeliverySectionStateProps {
  loading: boolean;
}

export interface DeliverySectionDispatchProps {
  onDetailsLinkClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible: () => void;
}

type DeliverySectionProps = DeliverySectionStateProps & DeliverySectionDispatchProps;

export const DeliverySection = ({
  loading,
  onDetailsLinkClick,
  onVisible,
}: DeliverySectionProps) => {
  const deliverySectionRef = useImpressionRef<HTMLDivElement>(() => onVisible());
  const skeletonCount = 2;
  const deliveryOptionsPlaceholderItems = Array.from({ length: skeletonCount });

  return (
    <div ref={deliverySectionRef}>
      {loading ? (
        <div css={styles.skeletonWrapper}>
          {deliveryOptionsPlaceholderItems.map((_, index) => (
            <SkeletonLabel key={`skeleton-${index}`} labelHeight="XL" />
          ))}
        </div>
      ) : (
        <DeliveryBlockContainer contextID={DeliveryBlockContextID.DeliveryOptions} />
      )}
      <a
        css={styles.drawerLink}
        href={`#${DELIVERY_DRAWER_URL_FRAGMENT_ID}`}
        onClick={onDetailsLinkClick}
      >
        Returns details <IconChevronRight color="var(--brand-purple-base)" height={16} width={16} />
      </a>
      <DeliveryAndReturnsDrawer target={deliverySectionRef} />
    </div>
  );
};
